import "../styles/css/admin-style.css"
import React, {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import {publicCustomerService} from "../services/publicCustomerService";
import {Controller, useForm} from "react-hook-form";
import {useAcceptJS} from "../shared/UseAcceptJS";
import notificationService from "../services/NotificationService";
import {formatCardNumber, getCardType, validateCardNumber} from "../shared/sharedFunctions";
import {authorize_net_client_key, authorize_net_login_id} from "../services/common.services";
import CustomInput from "../shared/components/CustomInput";
import EnlargeMapModal from "../components/PublicJobSchedule/EnlargeMapModal";
import DatePicker from "react-datepicker";
import {AvailableDatePicker} from "../shared/components/AvailableDatePicker";
import FormSelectCustom from "../shared/components/FormSelectCustom";
import {allStates, states} from "../shared/StatesDropdown";
import {Collapse} from "react-bootstrap";


const EstimateReschedulingPage: React.FC = () => {
    const auth = useContext(AuthenticationHandler);    
    const {state} = useLocation();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate()
    const { register, setValue, control, getValues, trigger, formState: {errors} } = useForm();
    const [map64, setMap64] = useState('')
    const [showMapModal, setShowMapModal] = useState(false)
    const [noDate, setNoDate] = useState(false)
    const [availableDates, setAvailableDates] = useState([])
    const [isScheduledToday, setIsScheduledToday] = useState(false)
    const [customerData, setCustomerData] = useState({
        firstName: '',
        lastName: '',
        standardizedAddress: '',
        homePhone: '',
        email: '',
        estimatedPriceLessPatchwork: 0,
        totalJobPrice: 0,
        priceAdjustments: [],
        webDiscountAmount: -0,
        patchworkPrice: 0,
        jobId: 0,
        jobDateScheduled: '',
    });
    function getMapBase64String() {
        if(map64 && map64 !== '')
            return `data:image/png;base64,${map64}`;
        return ''
    }
    useEffect(() => {
        document.body.classList.add('bg-white');
        if(state.requestData){
            const requestData = state.requestData;
            if(!requestData.homePhone){
                if(requestData.mobilePhone){
                    requestData.homePhone = requestData.mobilePhone
                } else if(requestData.workPhone){
                    requestData.homePhone = requestData.workPhone
                }
            }
            setMap64(requestData.imageDataBase64)
            setCustomerData(requestData)

            const today = new Date();
            const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
            if (requestData.jobDateScheduled === todayStr) {
                setIsScheduledToday(true);
            } else {
                publicCustomerService.getAvailableDates(auth.webIdUniqueToken, requestData.jobId).then(r => {
                    setAvailableDates(r.availableDates)
                })
            }
        }
    },[])

    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {


        const all = getValues()
        if (!all.scheduleDate) {
            notificationService.warning("Missing new reschedule date.");
            return;
        }
      
        setSubmitting(true);
        Promise.resolve(publicCustomerService.scheduleJob(auth.webIdUniqueToken, customerData.jobId, all.scheduleDate, null)).then(r => {
            setSubmitting(false)
            if(!r) return;
            navigate('/member/schedule-estimate/thanks');
        })
    };
    return (
        <>
            <div className="view-estimate-container">
                <div className="estimate-form">
                    <div className="mb-4">
                        <img src="/logo/logoBigger.svg" alt="Barreca Blacktopping" className="logo"/>
                    </div>
                    <div className="card p-4 mb-3">
                        <h3 className="mb-4 fw-bold"><i className="far fa-map-location-dot text-icon me-1"></i> Your Scheduled Work</h3>
                        <div className="row gx-5">
                            <div className="col-md-auto mb-3 mb-md-0 text-end">
                                <div className="map-thumbnail mb-2">
                                    <img alt='map' src={getMapBase64String()}/>
                                </div>
                                <a onClick={() => setShowMapModal(true)} role="button" data-bs-toggle="modal" data-bs-target="#map-modal">enlarge map <i
                                    className="far fa-external-link"></i></a>
                            </div>
                            <div className="col-md">
                                <div className="mb-2">
                                    <h3 className="mb-0">{customerData.firstName + ' ' + customerData.lastName}</h3>
                                    <label className="light-label">contact name</label>
                                </div>
                                <div className="mb-2">
                                    <h3 className="mb-0">{customerData.standardizedAddress}</h3>
                                    <label className="light-label">property</label>
                                </div>
                                <div className="mb-2">
                                    <h3 className="mb-0">{customerData.jobDateScheduled}</h3>
                                    <label className="light-label">Service Date</label>
                                </div>
                                {/*<div>
                                    <h3 className="mb-0"><span className="fst-italic text-black-50">pending</span></h3>
                                    <label className="light-label">Arrival Time</label>
                                </div>*/
                                }
                            </div>
                        </div>
                    </div>
                    {isScheduledToday ? (
                        <div className="card p-4">
                            <h3 className="mb-2 fw-bold"><i className="far fa-calendar-lines-pen text-icon me-1"></i> Need to reschedule?</h3>
                            <p className="mb-0 fs-5">Your service is scheduled for today and can no longer be rescheduled online. Please call Barreca Blacktop Sealcoating at <a href="tel:8479705900"><strong>(847) 970-5900</strong></a> to make changes.</p>
                        </div>
                    ) : (
                        <div className="card p-4">
                            <a className="" data-bs-toggle="collapse" onClick={() => setOpen(!open)} role="button"
                               aria-expanded="false" aria-controls="rescheduleDiv">
                                <h3 className="mb-0 fw-bold"><i className="far fa-calendar-lines-pen text-icon me-1"></i> I
                                    need to reschedule</h3>
                            </a>
                            <Collapse in={open}>
                                <div className="row mt-4 align-items-end">
                                    <div className="col-lg-6 mb-3 mb-lg-0">
                                        <AvailableDatePicker
                                            name="scheduleDate"
                                            label="Select Date"
                                            wrapperClassName="mb-0"
                                            required
                                            control={control}
                                            errors={errors}
                                            availableDates={availableDates.map(dateStr => {
                                                const [year, month, day] = dateStr.split("-").map(Number);
                                                return new Date(year, month - 1, day);
                                            })}
                                            className={'form-control form-control-lg'}
                                        />
                                    </div>
                                    <div className="col-auto d-flex align-items-end">
                                        <button disabled={submitting} onClick={handleSubmit} type="button"
                                                className="btn btn-primary btn-lg">
                                            <i className="far fa-check"></i> Submit Reschedule Request
                                        </button>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    )}

                    <div className="card p-4 bg-light-subtle mt-3">
                        <span className="fs-5">
                            <span className="text-black-50 me-2"><i className="fa-solid fa-poo-storm"></i></span>In case of rain, you will be contacted by a Barreca Blacktop Sealcoating representative to reschedule service.
                        </span>
                    </div>
                </div>
                <div className="estimate-sidebar">
                    <div className="esimate-cost p-3">
                        <label>Your estimate</label>
                        <h2>${customerData.totalJobPrice}</h2>
                    </div>
                    <hr/>
                    <div className="p-3">
                        <h3 className="mb-3">Summary</h3>
                        <div className="row mb-3 align-items-center justify-content-between">
                            <div className="col-auto">Sealcoating</div>
                            <div className="col-auto text-end">${customerData.estimatedPriceLessPatchwork}</div>
                        </div>
                        {customerData.patchworkPrice > 0 &&
                            <div className="row mb-3 align-items-center justify-content-between">
                                <div className="col-auto">Patchwork</div>
                                <div className="col-auto text-end">${customerData.patchworkPrice}</div>
                            </div>}
                        <div className="row align-items-center justify-content-between">
                            <div className="col-auto">Subtotal</div>
                            <div
                                className="col-auto text-end">${customerData.estimatedPriceLessPatchwork + customerData.patchworkPrice}</div>
                        </div>
                    </div>
                    <hr/>
                    {customerData.priceAdjustments.map(x => {
                        return (
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto">{x.adjustmentDescription}</div>
                                <div className="col-auto text-end text-success fw-bold">{x.adjustmentAmount}</div>
                            </div>
                        )
                    })}
                    <div className="row align-items-center justify-content-between">
                        <div className="col-auto">Web Discount</div>
                        <div className="col-auto text-end text-success fw-bold">{customerData.webDiscountAmount}</div>
                    </div>
                    <hr/>
                    <div className="row align-items-center justify-content-between mb-5">
                        <div className="col-auto">Total</div>
                        <div className="col-auto text-end text-primary fw-bold">${customerData.totalJobPrice}</div>
                    </div>
                    <div className="row">
                        <div className="col-auto">
                            <i className="fas fa-question-circle fa-2x" style={{color: "#C1CBCF"}}></i>
                        </div>
                        <div className="col">
                            <p className="mb-0"></p>
                        </div>
                    </div>
                </div>
            </div>
            <EnlargeMapModal base64String={map64} show={showMapModal} toggle={() => setShowMapModal(false)}/>
        </>
    )
}

export default EstimateReschedulingPage